import { ASSETS } from "@/lib/assets";

export const FOUNDER_PHOTO_URL =
  "https://customer-assets-eiarnc6j.emergentagent.net/job_wearspray-refresh/artifacts/5xrgjpf0_greg%20pic%20smiling%20July%202026%20.jpg";

// Slide number -> real photo to embed, and how wide its column should be (mm).
export const SLIDE_IMAGES = {
  "03": { url: ASSETS.fingerPressReservoir, colW: 80 },
  "10": { url: "/patents/certificate.png", colW: 80 },
  "14": { url: FOUNDER_PHOTO_URL, colW: 66 },
};

export const SLIDES = [
  {
    n: "01",
    label: "Less Friction, More Action",
    headline: "WearSpray connects personalized intelligence with immediate application.",
    body: "A patented refillable wrist dispenser keeps the user's chosen formulation within reach while a developing intelligence layer learns relevant routines, conditions and application moments. The missing link between knowing what to do and actually doing it is on the wrist.",
    extra: {
      type: "row",
      items: [
        ["Sense", ""],
        ["Understand", ""],
        ["Prompt", ""],
        ["Apply", ""],
        ["Learn", ""],
      ],
    },
    link: { label: "wearspray.com/science", url: "https://wearspray.com/science" },
  },
  {
    n: "02",
    label: "How It Works",
    headline: "Other wearables tell you it's time. WearSpray puts the formulation in your hand.",
    extra: {
      type: "list",
      items: [
        ["1. The band senses", "Sensor under the strap: skin temperature, sweat and heart rate. In development."],
        ["2. The AI learns", "Your routine, your formulation and local UV. In development."],
        ["3. The intelligence prompts", "It tells you when it's time to apply. In development."],
        ["4. You act and apply", "Already on your wrist. Available today."],
        ["5. It keeps learning", "Smarter with every prompt and your feedback. In development."],
      ],
    },
    link: { label: "wearspray.com/technology", url: "https://wearspray.com/technology" },
  },
  {
    n: "03",
    label: "The Mechanism",
    headline: "Fill it. Press it. Catch it. Apply it.",
    extra: {
      type: "list",
      items: [
        ["1. Fill", "Open the reservoir and fill it with your chosen lotion, gel or liquid."],
        ["2. Press", "Press the reservoir face with two fingers."],
        ["3. Catch and apply", "It dispenses into your other hand. Apply as directed."],
      ],
      footer: "Refillable 1 oz reservoir.",
    },
    link: { label: "wearspray.com/technology", url: "https://wearspray.com/technology" },
  },
  {
    n: "04",
    label: "The Gap",
    headline: "Personalization has an action problem.",
    body: "AI can recommend. Sensors can detect. Apps can remind. But none of that applies the product. WearSpray removes that friction by putting the user's chosen liquid, lotion or gel on the wrist.",
    extra: {
      type: "badges",
      items: ["Recommends", "Detects", "Reminds", "The Product \u2014 Not Yet Applied"],
    },
    link: { label: "wearspray.com/technology", url: "https://wearspray.com/technology" },
  },
  {
    n: "05",
    label: "Available Today",
    headline: "The formulation, on the wrist.",
    extra: {
      type: "list",
      items: [
        ["1 oz", "Refillable reservoir, worn all day. No bottle to carry."],
        ["Lotion, gel, liquid", "One device handles the formats brands already sell."],
        ["Mist and fragrance", "Interchangeable valves extend what it can deliver."],
      ],
      footer: "Manufactured and sold today: the dispenser. In development: sensors and a companion app.",
    },
    link: { label: "wearspray.com/products", url: "https://wearspray.com/products" },
  },
  {
    n: "06",
    label: "Why Now",
    headline: "AI and wearable sensing can finally understand when personal care is needed.",
    body: "But understanding is not enough. The product still has to be there.",
    extra: {
      type: "list",
      items: [
        ["AI can now personalize guidance in real time."],
        ["Wearables are already collecting biometric, behavioral and environmental signals at massive scale."],
        ["Consumers increasingly expect personalized skincare, wellness and health guidance."],
        ["Skincare companies are investing heavily in AI diagnostics, predictive science and personalization."],
        ["Sensors have become small and affordable enough to move into everyday wearable products."],
      ],
      footer: "Most wearable technology stops at awareness \u2014 WearSpray adds the action layer.",
    },
    link: { label: "wearspray.com/intelligence", url: "https://wearspray.com/intelligence" },
  },
  {
    n: "07",
    label: "Traction",
    headline: "The product exists. People have already bought it.",
    body: "We have never spent a dollar acquiring a customer. The dispenser is sold online as Safe Band Pro. This round funds the first real test of paid demand.",
    extra: {
      type: "stats",
      items: [
        ["$40K", "in sales, all word of mouth"],
        ["$0", "spent on marketing to date"],
        ["3,000", "units manufactured, approx."],
        ["4", "issued U.S. patents"],
      ],
    },
    link: { label: "wearspray.com/products", url: "https://wearspray.com/products" },
  },
  {
    n: "08",
    label: "First Pilot",
    headline: "Start where application is easy to measure.",
    body: "33% of U.S. adults typically reapply sunscreen every two hours as recommended (AAD survey, 2021).",
    extra: {
      type: "list",
      items: [
        ["Does wrist access change how often people reapply, compared with carrying a bottle?"],
        ["How much formulation do participants use each week?"],
        ["Do they keep wearing it after the first weeks?"],
        ["Do they buy refills?"],
      ],
      footer: "Proposed design: two groups of 100, wrist dispenser versus their usual bottle.",
    },
    link: { label: "wearspray.com/clinical", url: "https://wearspray.com/clinical" },
  },
  {
    n: "09",
    label: "Clinical & Adherence",
    headline: "The missing link between personalized skincare and patient adherence.",
    body: "Dermatologists and medical aesthetics partners invest heavily in personalized formulations and post-treatment recommendations. The piece still missing: whether patients keep using what's recommended once they leave the office.",
    extra: {
      type: "list",
      items: [
        ["1. Physician Recommendation", "A dermatologist or medical aesthetics provider recommends a personalized post-treatment or daily routine."],
        ["2. Personalized Guidance", "The regimen reflects the patient's specific treatment, skin type and goals."],
        ["3. Immediate Access", "WearSpray's wearable dispenser keeps the recommended formulation on the wrist, not in a bag or left at home."],
        ["4. Consistent Application", "Access removes one barrier to actually following through, day after day."],
      ],
      footer: "An evaluation concept, not a completed study. Clinical benefit remains to be validated.",
    },
    link: { label: "wearspray.com/clinical", url: "https://wearspray.com/clinical" },
  },
  {
    n: "10",
    label: "Defensibility",
    headline: "The hard part is already patented.",
    body: "An issued U.S. patent family covers refillable wearable dispensing, including a claim that pairs body sensing with the dispenser.",
    extra: {
      type: "list",
      items: [
        ["Issued", "3 utility patents (2022, 2023, 2025) and 1 design patent (2023)."],
        ["Issued Sensor Claim", "Claim 13 of US 12,285,084 covers the dispensing apparatus with at least one body sensor."],
        ["Described in the Family", "Dual reservoirs, phone-attached versions, displays, processors, alerts and connectivity."],
      ],
    },
    link: { label: "wearspray.com/patents", url: "https://wearspray.com/patents" },
  },
  {
    n: "11",
    label: "Landscape",
    headline: "The category is forming. The action layer is missing.",
    body: "Bottles deliver but do not sense. Wearables sense but do not deliver. Apps recommend but do not deliver. WearSpray connects intelligence with application. The same gap exists with a clinical audience: physicians personalize post-treatment routines but have no way to deliver on adherence, making medical aesthetics and dermatology an emerging vertical for the same action layer.",
    extra: {
      type: "table",
      columns: ["Category", "Worn", "Delivers", "Senses & Prompts"],
      rows: [
        { label: "Bottles, sticks, sprays", values: [false, true, false] },
        { label: "UV sensing wearables", values: [true, false, true] },
        { label: "Smartwatch reminders", values: [true, false, true] },
        { label: "WearSpray today", values: [true, true, false], highlight: true },
        { label: "WearSpray connected", values: [true, true, true], highlight: true },
      ],
    },
    link: { label: "wearspray.com/applications", url: "https://wearspray.com/applications" },
  },
  {
    n: "12",
    label: "Customer & Brand",
    headline: "Active consumers first. A wider skin care platform next.",
    body: "Built first for people whose personal care has to move with them.",
    extra: {
      type: "list",
      items: [
        ["First Customer", "Active women, about 25 to 40. Already buy skin care, spend long days away from home."],
        ["Entry Point", "Sunscreen on active days. The same dispenser holds other liquids, lotions and gels."],
        ["Brand Partners", "Easier, appropriate application may support the product experience and repeat purchasing."],
      ],
      footer: "Entry market: global sun care, about $15.5B in 2025 \u2014 Fortune Business Insights.",
    },
    link: { label: "wearspray.com/market", url: "https://wearspray.com/market" },
  },
  {
    n: "13",
    label: "Business Model",
    headline: "Devices first. Recurring revenue next.",
    extra: {
      type: "list",
      items: [
        ["Now \u2014 Device sales, direct and co-branded", "Target: $49 retail, under $12 unit cost, about 75% gross margin."],
        ["Next \u2014 Formulation refills and brand licensing", "30% of buyers purchase a refill within 90 days."],
        ["Parallel \u2014 Clinical collaboration and medical licensing", "Medical aesthetics and dermatology partners exploring adherence pilots and brand or technology licensing."],
        ["Later \u2014 Personalized digital services", "Whether connected features keep people applying."],
      ],
    },
    link: { label: "wearspray.com/applications", url: "https://wearspray.com/applications" },
  },
  {
    n: "14",
    label: "Team",
    headline: "The people behind the product.",
    extra: {
      type: "list",
      items: [
        ["Greg Demirjian \u2014 Founder, CEO & Inventor", "Took the patented product from concept through manufacturing, launch and Shark Tank."],
        ["The Faction (Matt Murphy & Beth Wilson) \u2014 App & Sensor Development", "Lead the companion app and sensor work.", "https://mattmurphy.ai/community/"],
        ["Neo IP \u2014 Patent Counsel", "Supports portfolio strategy and continuation filings.", "https://neoipassets.com/"],
        ["Momentum \u2014 Sensor Integration Partner (exploring)", "Open Wearables unifies data from Garmin, Oura, Whoop, Apple Health and other sensors into one API, a potential bridge between third-party wearables and WearSpray IQ.", "https://themomentum.ai/"],
        ["Clinical Advisor \u2014 Dermatology Partner (exploring, open seat)", "An open advisory seat for a dermatologist or medical aesthetics physician to guide the Clinical & Adherence program."],
      ],
      footer: "Hiring with the seed round: Head of Hardware Engineering, full time.",
    },
  },
  {
    n: "15",
    label: "The Raise",
    headline: "$600K to prove the closed loop.",
    body: "This round takes WearSpray from a patented, manufactured dispenser to a measured connected platform.",
    extra: {
      type: "list",
      items: [
        ["Prove paid demand"],
        ["Build the companion intelligence layer"],
        ["Integrate the body sensor"],
        ["Measure application behavior"],
        ["Run the first brand pilots"],
      ],
      footer: "Next: $2M+ seed round \u2014 get in touch",
      footerLink: "mailto:greg@wearspray.com?subject=WearSpray%20Investment%20Inquiry",
    },
  },
  {
    n: "16",
    label: "The Big Question",
    headline: "If the product were already on your wrist, would you use it more often?",
    body: "Better access can drive better adherence. Better adherence gives formulations more chances to work, and more use creates value for consumers and brands.",
    extra: {
      type: "list",
      items: [
        ["Today", "Only 33% of U.S. adults reapply sunscreen as recommended."],
        ["This round", "A 200-user pilot measures whether wrist access changes behavior."],
      ],
    },
  },
  {
    n: "17",
    label: "Where It's Going",
    headline: "AI that does not stop at the recommendation.",
    body: "It helps turn the recommendation into action. The next generation of personal care will not simply understand what your skin needs. It will help make sure the product is there when you need it. One platform, five opportunities: medical aesthetics & dermatology, consumer skincare, healthcare & sanitization, personal protection and global health.",
    extra: {
      type: "row",
      items: [
        ["Sense", "UV, heat, humidity"],
        ["Understand", "Routines, context"],
        ["Prompt", "Time to apply"],
        ["Act", "One press"],
        ["Learn", "Patterns improve"],
      ],
    },
    link: { label: "wearspray.com/applications", url: "https://wearspray.com/applications" },
  },
];
